import axios from "axios"
import { isAuthenticated, logout, getToken } from "./Auth";
const API_URL = process.env.REACT_APP_BASE_URL;

var axiosApi = axios.create({
  baseURL: API_URL,
})
axiosApi.interceptors.response.use(function (response) {
  const statusCode = response.data.statusCode;
  if(statusCode === 1500){
    logout()
    window.location = "/login"
    return response;
  }
  else{
    return response;
  }
}, function (error) {
  return Promise.reject(error);
});

// Login Method
export const postLogin = (url, data) => {
  // return axios.post(API_URL+"en-us/admin"+url, data).then(response => {
  return axios.put(API_URL+url, data).then(response => {
      if (response.status === 400 || response.status === 500) {
          throw "Sorry! Something went wrong, please contact our support team";
      }
      if (!response.data.success) {
          throw "Please provide a valid email address and password";
      }
      return response.data;
  }).catch(err => {
      throw "Please provide a valid email address and password";
  });
}
export const forgotPassword = (url, data) => {
  return axios.post(API_URL+"en-us/admin"+url, data).then(response => {
      if (!response.data.status) {
        throw "Sorry! Something went wrong, please contact our support team";
      }
      return response.data;
  }).catch(err => {
      throw "Sorry! Something went wrong, please contact our support team";
  });
}
export const resetPassword = (url, data) => {
  return axios.post(API_URL+"en-us/admin"+url, data).then(response => {
      if (!response.data.status) {
        throw "Sorry! Something went wrong, please contact our support team";
      }
      return response.data;
  }).catch(err => {
      throw "Sorry! Something went wrong, please contact our support team";
  });
}

export async function apiWrapper(callback , url, data = {},config = {},locale = ""){
  if(isAuthenticated()){
    return callback(url,data,config, "Bearer "+getToken());
  }
  else{
    logout();
    window.location = "/login";
  }
}


export async function get(url, params = {}, config = {}, token) {
  axiosApi.defaults.headers.common["Authorization"] = await token;
  let p = Object.keys(params).map(key => key + '=' + params[key]).join('&');
  if(params && Object.keys(params).length > 0){
    return axiosApi.get(url+"?"+p, { ...config });
  }
  return axiosApi.get(url, { ...config });
  
}

export async function post(url, data = {}, config = {}, token) {
  axiosApi.defaults.headers.common["Authorization"] = await token;
  // let configuration = { headers: { 'content-type': 'multipart/form-data' } }
  console.log("config post", config)
  return axiosApi.post(url, { ...data }, config );
}

export async function postForm(url, formData, headers = {}, token) {
  axiosApi.defaults.headers.common["Authorization"] = await token;
  let configuration = { headers: { 'content-type': 'multipart/form-data', ...headers } }
  console.log('configuration', configuration)
  return axiosApi.post(url, formData, configuration);
}

export async function put(url, data, config = {}, token) {
  axiosApi.defaults.headers.common["Authorization"] = await token;
  return axiosApi.put(url, { ...data }, { ...config });
}

export async function putForm(url, formData, headers = {}, token) {
  axiosApi.defaults.headers.common["Authorization"] = await token;
  let configuration = { headers: { 'content-type': 'multipart/form-data', ...headers } }
  return axiosApi.put(url, formData, configuration);
}

export async function del(url, data = {}, config = {}, token) {
  axiosApi.defaults.headers.common["Authorization"] = await token;
  return await axiosApi.delete(url, { data : { ...data } , ...config });
}

export async function patch(url, data = {}, config = {}, token) {
  axiosApi.defaults.headers.common["Authorization"] = await token;
  return axiosApi.patch(url, { ...data }, { ...config });
}